import { useState, useEffect } from "react";
import { useLang } from "@/lib/i18n";
import api from "@/lib/api";

const PRAYERS = [
  { key: "Fajr", label: "prayer_fajr" },
  { key: "Dhuhr", label: "prayer_dhuhr" },
  { key: "Asr", label: "prayer_asr" },
  { key: "Maghrib", label: "prayer_maghrib" },
  { key: "Isha", label: "prayer_isha" },
];

export const PrayerTimesRow = ({ slug, mosqueId, title, className = "" }) => {
  const { t } = useLang();
  const [prayers, setPrayers] = useState(null);

  useEffect(() => {
    api.get(`/associations/${slug}/mosques/${mosqueId}/prayer-times`)
      .then(({ data }) => setPrayers(data))
      .catch(() => setPrayers(null));
  }, [slug, mosqueId]);

  if (!prayers?.timings) return null;

  const now = new Date();
  const nowMin = now.getHours() * 60 + now.getMinutes();
  const toMin = (hm) => {
    const [h, m] = (hm || "").split(":").map(Number);
    return isNaN(h) ? -1 : h * 60 + m;
  };
  const nextKey = PRAYERS.find((p) => toMin(prayers.timings[p.key]) >= nowMin)?.key;

  const grid = (
    <div className="grid grid-cols-5 divide-x divide-border border-t border-border" data-testid="my-mosque-prayer-times">
      {PRAYERS.map((p) => {
        const isNext = p.key === nextKey;
        return (
          <div key={p.key} className={`px-1 py-2 text-center ${isNext ? "bg-accent/10" : ""}`} data-testid={`prayer-time-${p.key.toLowerCase()}`}>
            <p className={`text-[9px] font-mono-data uppercase tracking-wider ${isNext ? "text-accent font-semibold" : "text-muted-foreground"}`}>{t(p.label)}</p>
            <p className={`text-xs font-mono-data mt-0.5 ${isNext ? "text-accent font-bold" : "font-medium"}`}>{prayers.timings[p.key] || "—"}</p>
          </div>
        );
      })}
    </div>
  );

  if (!title) return grid;

  return (
    <div className={`border border-border rounded-lg bg-card overflow-hidden ${className}`} data-testid="mosque-prayer-card">
      <div className="flex items-baseline justify-between px-5 py-3">
        <p className="text-[11px] font-mono-data uppercase tracking-wider text-muted-foreground">{title}</p>
        <p className="text-[10px] font-mono-data text-muted-foreground">{prayers.method}</p>
      </div>
      {grid}
    </div>
  );
};
